import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-search-rounded',
    templateUrl: './search-rounded.component.html',
    styleUrls: ['./search-rounded.component.scss'],
    standalone: false
})
export class SearchRoundedComponent {
  @Input() name: string | undefined ="";
  @Input() placeholder: string = 'Search';
  @Output() searchEmitter: EventEmitter<string> = new EventEmitter<string>();

  onSearchInput(event: Event | string): void {
    let searchString: string = typeof event === 'string' ? event : (event.target as HTMLInputElement).value;
    this.searchEmitter.emit(searchString.trim());
  }
}
